import { h } from "preact";

export default function Info() {
  // Subtitle is shown in Questions.jsx, so nothing to do here
  return <span></span>;
}
